import React, { Component } from "react";
import { connect } from "react-redux";
import { showMessage, showError, confirmAction } from "../../actions/uiActions";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import DomainsApi from "../../api/domains";
import PaginatedTable from "../../components/PaginatedTable";
import Domain from "../../forms/Domain";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import Config from "../../config/env";
import DomainString from "../../forms/DomainString";
import DomainSurvey from "../../forms/DomainSurvey";
import Group from "@mui/icons-material/Group";
import { withRouter } from "../../utils/withRouter";
import SplashPage from "../../components/SplashPage";
import { TextField } from "@mui/material";
import { debounce } from "lodash";

class Domains extends Component
{
  state = {
    domains: [],
    loading: true,
    domain: null,
    count: 0,
    page: 0,
    mode: "default",
    deleting: false,
    strings: false,
    survey: false,
    downloading: false,
    splashPage: false,
    search: "",
  };
  constructor(props)
  {
    super(props);
    this.debouncedSearch = debounce((searchValue) =>
    {
      this.load(0, searchValue);
    }, 500);
  }

  componentDidMount()
  {
    this.load();
  }

  load = (page = 0, search = this.state.search) =>
  {
    DomainsApi.load(page, search)
      .then(
        (result) =>
          this.setState({
            loading: false,
            domains: result.domains,
            page: result.page,
            pages: result.pages,
            count: result.count,
          }),
        (error) =>
        {
          this.setState({ loading: false }, this.props.showError);
        },
      )
      .catch((error) =>
      {
        this.setState({ loading: false }, this.props.showError);
      });
  };
  delete = (id) =>
  {
    this.props.confirmAction(
      "You are going to delete this domain permanentely, therefore users will no longer be able to have access to ED through this domain name. Do you want to proceed?",
      () =>
        this.setState({ deleting: true, domain: { _id: id } }, () =>
          DomainsApi.delete(id)
            .then(
              (success) =>
              {
                this.props.showMessage("The Domain has been deleted");
                this.load(this.state.page);
              },
              (error) =>
                this.setState(
                  { deleting: false, domain: null },
                  this.props.showError,
                ),
            )
            .catch((error) =>
              this.setState(
                { deleting: false, domain: null },
                this.props.showError,
              ),
            ),
        ),
    );
  };
  downloadSurvey = () =>
  {
    this.setState({ downloading: true }, () =>
      DomainsApi.downloadSurvey(this.state.domain._id, this.state.domain.domain)
        .then(
          (success) => this.setState({ downloading: false }),
          (error) =>
            this.setState({ downloading: false }, this.props.showError),
        )
        .catch((error) =>
          this.setState({ downloading: false }, this.props.showError),
        ),
    );
  };

  searchDomain = (e) =>
  {
    const value = e.target.value;
    this.setState({ search: value });
    this.debouncedSearch(value);
  };

  render()
  {
    return (
      <section className="animated fadeIn">
        <header>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h1>
              Domains Management
              {this.state.mode == "add"
                ? ` > Add New Domain`
                : this.state.mode == "edit"
                  ? ` > Edit Domain > ${this.state.domain.name}`
                  : ""}
            </h1>
            {this.state.mode == "default" && (
              <div className="form-group nice">
                <TextField
                  placeholder="Search domain by description or name"
                  label="Search Domains:"
                  sx={{
                    width: "500px",
                  }}
                  value={this.state.search}
                  onChange={this.searchDomain}
                />
              </div>
            )}
          </div>
          {this.state.mode != "default" && (
            <div className="actions mt-4">
              {this.state.mode == "edit" && this.state.domain && (
                <button
                  onClick={() =>
                    this.props.history.push(
                      `/upload-ein/${this.state.domain._id}`,
                    )
                  }
                >
                  EINs
                </button>
              )}
              {this.state.mode == "edit" &&
                this.state.domain &&
                this.state.domain.survey && (
                  <button
                    disabled={this.state.downloading}
                    onClick={this.downloadSurvey}
                  >
                    {this.state.downloading
                      ? "Downloading Survey..."
                      : "Download Survey"}
                  </button>
                )}
              {this.state.mode == "edit" && this.state.domain && (
                <button onClick={() => this.setState({ strings: true })}>
                  Customize Strings
                </button>
              )}
              {this.state.mode == "edit" && this.state.domain && (
                <button onClick={() => this.setState({ survey: true })}>
                  Customize Survey
                </button>
              )}
              {this.state.mode == "edit" && this.state.domain && (
                <button onClick={() => this.setState({ splashPage: true })}>
                  Customize Splash Page
                </button>
              )}
              {this.state.mode == "edit" && this.state.domain && (
                <button
                  onClick={() =>
                    this.props.history.push(
                      `/domain/${this.state.domain._id}/sso-configuration`,
                    )
                  }
                >
                  SSO configuration
                </button>
              )}
              <button
                onClick={() => this.setState({ mode: "default", domain: null })}
              >
                Close
              </button>
            </div>
          )}
          {this.state.mode == "default" && (
            <Tooltip
              title="Add new Domain"
              placement="top"
              className="floating-button"
            >
              <Fab
                onClick={() => this.setState({ mode: "add" })}
                variant="round"
                color="primary"
                aria-label="Add"
              >
                <Add />
              </Fab>
            </Tooltip>
          )}
        </header>
        <div className="line-break"></div>
        {(this.state.mode == "add" || this.state.mode == "edit") && (
          <Domain
            domain={this.state.domain}
            onClose={() => this.setState({ mode: "default", domain: null })}
            onUpdate={(updatedDomain) =>
              this.setState({
                domains: this.state.domains.map((domain) =>
                {
                  if (domain._id == updatedDomain._id) return updatedDomain;
                  return domain;
                }),
              })
            }
            onCreate={() => this.load(this.state.page)}
          />
        )}
        {this.state.mode == "default" && (
          <div className="row">
            <div className="col-12">
              <Paper>
                <PaginatedTable
                  goToPage={this.load}
                  count={parseInt(this.state.count.toString())}
                  page={parseInt(this.state.page.toString())}
                  loading={this.state.loading}
                  rows={this.state.domains.map((domain) =>
                  {
                    return {
                      properties: {
                        key: domain._id,
                      },
                      columns: [
                        {
                          properties: {
                            key: `${domain._id}-1`,
                          },
                          value: `${Config.appDomain}/${domain.domain}`,
                        },
                        {
                          properties: {
                            key: `${domain._id}-3`,
                          },
                          value: domain.name,
                        },
                        {
                          properties: {
                            key: `${domain._id}-3`,
                          },
                          value: domain.ssoConfigurations?.filter((config) => config.status).length > 0 ? "Yes" : "No",
                        },
                        {
                          properties: {
                            key: `${domain._id}-4`,
                          },
                          value: (
                            <div className="text-center">
                              <Tooltip title="Edit Domain">
                                <IconButton
                                  onClick={() =>
                                    this.setState({ mode: "edit", domain })
                                  }
                                >
                                  <Edit />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Add Domain Admin">
                                <IconButton
                                  onClick={() =>
                                    this.props.history.push(
                                      `/domain/${domain._id}/admin-page`,
                                    )
                                  }
                                >
                                  <Group />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete Domain">
                                <IconButton
                                  disabled={
                                    this.state.deleting &&
                                    this.state.domain &&
                                    this.state.domain._id == domain._id
                                  }
                                  onClick={() => this.delete(domain._id)}
                                >
                                  {(!this.state.deleting ||
                                    !this.state.domain ||
                                    this.state.domain._id != domain._id) && (
                                      <Delete />
                                    )}
                                  {this.state.domain &&
                                    this.state.domain._id == domain._id && (
                                      <CircularProgress size={24} />
                                    )}
                                </IconButton>
                              </Tooltip>
                            </div>
                          ),
                        },
                      ],
                    };
                  })}
                  emptyMessage={
                    this.state.search
                      ? "No matching domains found"
                      : "No domains have been added"
                  }
                  columns={[
                    {
                      name: "APP Url",
                      properties: {
                        key: 1,
                        className: "width40pct",
                      },
                    },
                    {
                      name: "Domain Description",
                      properties: {
                        key: 3,
                        className: "width40pct",
                      },
                    },
                    {
                      name: "SSO enabled",
                      properties: {
                        key: 4,
                        className: "width40pct",
                      },
                    },
                    {
                      name: "Options",
                      properties: {
                        key: 5,
                        className: "width20pct",
                      },
                    },
                  ]}
                />
              </Paper>
            </div>
          </div>
        )}
        {this.state.mode == "edit" &&
          this.state.domain &&
          this.state.strings && (
            <DomainString
              domain={this.state.domain}
              onCancel={() => this.setState({ strings: false })}
              onStringUpdated={(string_id, string_text) =>
              {
                this.setState({
                  domains: this.state.domains.map((domain) =>
                  {
                    if (domain._id === this.state.domain._id)
                    {
                      domain.strings = {
                        ...(domain.strings || {}),
                        [string_id]: string_text,
                      };
                    }
                    return domain;
                  }),
                });
              }}
            />
          )}

        {this.state.mode == "edit" &&
          this.state.domain &&
          this.state.survey && (
            <DomainSurvey
              id={this.state.domain._id}
              onClose={() => this.setState({ survey: false })}
              survey={this.state.domain.survey}
              onSurveyUpdated={(id, survey) =>
              {
                this.setState({
                  domains: this.state.domains.map((domain) =>
                  {
                    if (domain._id === id)
                    {
                      domain.survey = survey;
                    }
                    return domain;
                  }),
                });
              }}
            />
          )}
        {this.state.mode === "edit" &&
          this.state.domain &&
          this.state.splashPage && (
            <SplashPage
              domain={this.state.domain}
              onClose={() => this.setState({ splashPage: false })}
              onSplashPageUpdated={(id, splashPage) =>
              {
                this.setState({
                  domains: this.state.domains.map((domain) =>
                  {
                    if (domain._id === id)
                    {
                      domain.splashPageConfig = splashPage;
                    }
                    return domain;
                  }),
                });
              }}
            />
          )}
      </section>
    );
  }
}
export default withRouter(
  connect(null, { showError, showMessage, confirmAction })(Domains),
);
